import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ObjectField } from 'src/app/model/Plan';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../actionmenu/action-menu.component';
import { ColumnType, DataTableColumn, DataTableDropDownData, DataTableDropDownOption, DataTableRow } from '../datatable/datatable.component';

@Component({
    selector: 'app-object-list',
    templateUrl: './object-list.component.html',
    styleUrls: ['./object-list.component.css'],
    standalone: false
})
export class ObjectListComponent implements OnInit {

  @Input() objectDefinition: Record<string, ObjectField>;
  @Input() objectList: Record<string, ObjectField>[];
  @Input() identifier: string = '';

  @Output() onObjectListChange: EventEmitter<Record<string, ObjectField>[]> = new EventEmitter();
  
  cols:DataTableColumn[] = [];
  rows:DataTableRow[] = [];
  isLoading: boolean = false;
  defaultData:any = {};

  constructor() { }

  ngOnInit(): void {
    if(this.objectDefinition){
      let fields:ObjectField[] = Object.values(this.objectDefinition);
      fields.sort((a, b) => (a.order > b.order ? 1 : -1)); //sort by order
      

      fields.forEach( field => {
        this.cols.push(new DataTableColumn(field.name, field.name, this.getColumnFieldType(field.type),
                                            false, (100 / fields.length).toString()));
        
        if(field.type == 'STRING'){
          this.defaultData[field.name] = field.value;
        }else  if(field.type == 'LIST'){
          let options:DataTableDropDownOption[] = [];
          let selectedIndex:number = -1;

          field.defaultListValue.forEach( (list, index) => {
            options.push(new DataTableDropDownOption(list.name, list.value));
            if(list.selected){
              selectedIndex = index;
            }
          })
          this.defaultData[field.name] = new DataTableDropDownData(selectedIndex > -1 ? options[selectedIndex].name : '' , options);
          this.defaultData[field.name].altText = '';
        }
      });

      if(this.objectList.length > 0){
        this.objectList.forEach((obj) => {
          let fields:ObjectField[] = Object.values(obj);
          fields.sort((a, b) => (a.order > b.order ? 1 : -1)); //sort by order
          let data:any = {};
  
          fields.forEach( field => {
            if(field.type == 'STRING'){
              data[field.name] = field.value;
            }else  if(field.type == 'LIST'){
              let options:DataTableDropDownOption[] = [];
    
              field.defaultListValue.forEach( (list, index) => {
                options.push(new DataTableDropDownOption(list.name, list.value));
              })
              data[field.name] = new DataTableDropDownData(field.value , options);
              data[field.name].altText = '';
            }
          });
  
          this.rows.push(new DataTableRow(data, []));
        });
      }else{
        this.rows.push(new DataTableRow(this.defaultData, []));
      }
      this.setActionMenus();
      this.isLoading = false;
    }
  }

  setActionMenus(): void {
    this.rows.forEach( (row, index) => {
      if(this.rows.length == 1){
        row.actions = [];
      }else {
        row.actions = [new ActionMenuItem("Remove", $localize`Remove`, ActionMenuIcon.DELETE, undefined, true)];
      }
    });
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Remove"){
      this.rows = this.rows.filter( (row) => {
        return !row.selected;
      });

      this.updateValue();
      
      if(this.rows.length == 0){
        this.addEmptyRow();
      }
    }

    this.setActionMenus();
  }

  updateValue(): void{
    let tempObjectList: Record<string, ObjectField>[] = [];

    this.rows.forEach( (row) => {
      let objDef: Record<string, ObjectField> = JSON.parse(JSON.stringify(this.objectDefinition));
      Object.keys(row.data).forEach(key => {
        if(key !== 'filtered'){
          if(objDef[key].type == 'STRING'){
            objDef[key].value = row.data[key];
          }else if(objDef[key].type == 'LIST'){
            objDef[key].value = row.data[key].value;
          }
        }
      });
      tempObjectList.push(objDef);
    });
    this.onObjectListChange.emit(tempObjectList);
  }

  addEmptyRow(): void {
    let tmpRows: DataTableRow[]  = JSON.parse(JSON.stringify(this.rows));
    tmpRows.push(new DataTableRow(JSON.parse(JSON.stringify(this.defaultData)), []));
    this.rows = tmpRows;
    this.setActionMenus();
  }

  private getColumnFieldType(type:string): ColumnType{
    let colType: ColumnType;

    switch(type){
      case 'STRING': colType = ColumnType.TEXTBOX;
                      break;
      case 'LIST': colType = ColumnType.DROPDOWN;
                      break;
    }

    return colType;
  }
}
